import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React from 'react';
import { useDefaultComponentValue } from '../../../utils/useDefaultComponentValue';
import FormGroupControl from '../FormGroupControl';
import FormGroupLabel from '../FormGroupLabel';
import FormGroupValidation from '../FormGroupValidation';
const COMPONENT_NAME = 'FormGroup';
const FormGroup = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { children, className, labelClassName, label, labelPosition, controlClassName, validation, validationClassName, ...other } = props;
    const controlElement = children ? /*#__PURE__*/ React.createElement(FormGroupControl, {
        className: controlClassName
    }, children) : null;
    const validationElement = validation ? /*#__PURE__*/ React.createElement(FormGroupValidation, {
        className: validationClassName
    }, validation) : null;
    const labelElement = label ? /*#__PURE__*/ React.createElement(FormGroupLabel, {
        className: labelClassName,
        position: labelPosition
    }, label) : null;
    return /*#__PURE__*/ React.createElement("div", {
        className: cx('FormGroup', className),
        ...other
    }, labelElement, controlElement, validationElement);
};
FormGroup.propTypes = {
    /**
	 * Children will be rendered within the FormGroupControl element.
	 */ children: PropTypes.node.isRequired,
    /**
	 * Root className.
	 */ className: PropTypes.string,
    /**
	 * ClassName applied to control element
	 */ controlClassName: PropTypes.string,
    /**
	 * Node element that is displayed as label when filled in
	 */ label: PropTypes.node,
    /**
	 * ClassName applied to label
	 */ labelClassName: PropTypes.string,
    /**
	 * `left` or `right` values for label positioning
	 */ labelPosition: PropTypes.oneOf(FormGroupLabel.positions.values()),
    /**
	 * Validation node element that display validation messages.
	 * ValidationFieldMessage component is ideal candidate to be used.
	 */ validation: PropTypes.node,
    /**
	 * ClassName applied to validation element
	 */ validationClassName: PropTypes.string
};
FormGroup.labelPositions = FormGroupLabel.positions;
export default FormGroup;
